import { render, staticRenderFns } from "./ListAnnotationsByTerm.vue?vue&type=template&id=141d7138&scoped=true&"
import script from "./ListAnnotationsByTerm.vue?vue&type=script&lang=js&"
export * from "./ListAnnotationsByTerm.vue?vue&type=script&lang=js&"
import style0 from "./ListAnnotationsByTerm.vue?vue&type=style&index=0&id=141d7138&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "141d7138",
  null
  
)

export default component.exports